{
  "error": "Fejl",
  "help": "Hjælp",
  "info": "Oplysninger",
  "success": "Fuldført",
  "warning": "Advarsel"
}
